import { useState } from '#imports'

import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

export function useProductDesyncValidator() {
  const logger = useLogger()

  const clickedProductCardData = useState('clickedProductCardData', () => ({
    listingId: '',
    price: '',
  }))

  function storeProductCardData(productCard: {
    listingId: string
    price: string
  }) {
    clickedProductCardData.value = productCard
  }

  function validateProductData(productData: {
    listingId: string
    price: string
    isOutOfStock: boolean
  }) {
    if (!clickedProductCardData.value.listingId) return

    if (productData.isOutOfStock) {
      logger.info('[S&R][Error][ProductPage] Stock desync detected', {
        source: 'productPage',
        CardListingId: clickedProductCardData.value.listingId,
        PDPListingId: productData.listingId,
        owners: ['bot-squad-search-and-recommendation-front'],
      })

      clickedProductCardData.value = {
        listingId: '',
        price: '',
      }

      return
    }

    if (clickedProductCardData.value.listingId !== productData.listingId) {
      logger.info('[S&R][Error][ProductPage] Listing desync detected', {
        source: 'productPage',
        CardListingId: clickedProductCardData.value.listingId,
        PDPListingId: productData.listingId,
        owners: ['bot-squad-search-and-recommendation-front'],
      })
    }

    if (clickedProductCardData.value.price !== productData.price) {
      logger.info('[S&R][Error][ProductPage] Price desync detected', {
        source: 'productPage',
        CardListingId: clickedProductCardData.value.listingId,
        PDPListingId: productData.listingId,
        owners: ['bot-squad-search-and-recommendation-front'],
      })
    }

    clickedProductCardData.value = {
      listingId: '',
      price: '',
    }
  }

  return {
    storeProductCardData,
    validateProductData,
  }
}
